//
//
//
//
//
//

import gameCont from '../game/index.vue'
export default {
  name: "fish",
  components: {gameCont},
  data() {
    return {
      gameTypeCode: '5',
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/build922/views/home/pages-5.vue